import { Configuration } from "@azure/msal-browser";
import { AppConfig } from "../AppConfig";

export const loginRequest = {
    scopes: ["User.Read"], // Specify the API permissions your app needs
  };

  // The main configuration for MSAL (Microsoft Authentication Library)
export const msalConfig: Configuration = {
    auth: {
      clientId: AppConfig.AZURE_CLIENT_ID as string,            // Your Azure AD Application's unique ID
      authority: AppConfig.AZURE_AUTHORITY, // Authority URL, typically pointing to your Azure AD tenant
      redirectUri: AppConfig.AZURE_REDIRECT_URI,     // Where the user is redirected after authentication (must be registered in Azure)
    },
  };